import Layout from "../../layout/main";
import WalletCardManagement from "../../components/walletCardManagement";
/**
 * WalletBalanceReportsPage
 *
 * صفحه گزارش ها موجودی نقدی کیف پول.
 * رندر کامپوننت WalletBalanceReports داخل لایه اصلی Layout برای نمایش گزارش ها کیف پول.
 *
 * @returns JSX.Element
 */

const WalletCardManagementPage = () => {
  return (
    <Layout>
      <WalletCardManagement />
    </Layout>
  );
};

export default WalletCardManagementPage;
